/**
 * Pure SSO token expiration helpers — aligned with loginTokenMapping / loginTokenListMapping in iccMappings.
 */

export const DEFAULT_SSO_TOKEN_EXPIRATION_FALLBACK_MS = 5 * 60_000;

/**
 * Maps ICC ExpiryDate to epoch ms. If the date is missing, invalid, or not in the future,
 * returns now + 5 minutes (same as legacy loginTokenMapping).
 */
export const normalizeExpirationFromIccExpiryDate = (expiryDateInput: unknown, nowMs: number = Date.now()): number => {
    if (expiryDateInput == null || expiryDateInput === '') {
        return nowMs + DEFAULT_SSO_TOKEN_EXPIRATION_FALLBACK_MS;
    }

    const expiryDate = new Date(expiryDateInput as string | number | Date);
    const expiryTime = expiryDate.getTime();

    if (Number.isNaN(expiryTime)) {
        return nowMs + DEFAULT_SSO_TOKEN_EXPIRATION_FALLBACK_MS;
    }

    const isExpiryDateValid = expiryTime > nowMs;

    return isExpiryDateValid ? expiryTime : nowMs + DEFAULT_SSO_TOKEN_EXPIRATION_FALLBACK_MS;
};

/** Milliseconds until expiration; negative if already expired (matches prior iccSsoService.getLinkExpiration). */
export const getLinkExpiration = (
    expirationDateMs: number,
    nowMs: number = Date.now()
): {expiredInMs: number; isExpired: boolean} => {
    const expiredInMs = expirationDateMs - nowMs;

    return {
        expiredInMs,
        isExpired: expiredInMs < 0,
    };
};
